module.exports = __webpack_public_path__ + "static/media/example01-01.6d128e7f.svg";